module.exports = __webpack_public_path__ + "static/img/banner3.5f2670b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.jpg
// module id = GWCu
// module chunks = 1